module.exports = __webpack_public_path__ + "img/tanchuan-04.4d9e2142.svg";